import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';
import { useContext } from 'react';
import SunnyIcon from '@mui/icons-material/Sunny';
import BedtimeOutlinedIcon from '@mui/icons-material/BedtimeOutlined';
import NavigationButton from './navigation/NavigationButton';

// Switch personalizado optimizado para fondo oscuro
const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 52,
    height: 26,
    padding: 0,
    margin: 8,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(26px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#374151', // Color oscuro para modo oscuro
                opacity: 1,
                border: 0,
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#fff',
                '&:before': {
                    content: "'🌙'",
                },
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
        width: 22,
        height: 22,
        '&:before': {
            content: "'☀️'",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
        },
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#374151', // Color gris oscuro para modo claro
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const ToggleSwitchMode = () => {
    const { state, dispatch } = useContext(Context);

    const isDarkMode = state.theme === 'dark';
    const size = 20;

    const handleThemeChange = () => {
        dispatch({ type: REDUCERS.UPDATE_THEME, payload: isDarkMode ? 'light' : 'dark' });
        localStorage.setItem('af-theme', isDarkMode ? 'light' : 'dark');
    };

    const styles = {
        width: size,
        height: size,
        color: '#ccc',
    };

    return (
        <NavigationButton onClick={handleThemeChange}>
            {isDarkMode ? <BedtimeOutlinedIcon sx={styles} /> : <SunnyIcon sx={styles} />}
        </NavigationButton>
    );
};

export default ToggleSwitchMode;
